import React from "react";
import { useFluidForm, useFormInstance } from "../FormContext";
import { useFormInstanceDispatch } from "../FormInstance.service";
export function FormLabel({ color, config, options, fieldPath }) {
    let fieldName = fieldPath;
    let instanceId = useFormInstance();
    const fluidForm = useFluidForm();
    const fieldLabel = config?.label || config?.key;
    let dispatch = useFormInstanceDispatch(instanceId);
    let sectionPath = Object.values(fluidForm.getSectionsPath(fieldPath)).map(section => section?.label).join(" • ");
    return (React.createElement("div", { className: "group relative flex items-center mt-2 text-left" },
        React.createElement("label", { className: "block text-xs font-medium fluid-label", htmlFor: `ff-${fieldName}`, onClick: (e) => {
                //Focus next input
                let nextElement = document.querySelector(`[data-fieldName="${fieldName}"]`);
                if (nextElement) {
                    //@ts-ignore
                    nextElement.focus();
                }
            } }, config.label),
        !options?.hideHelpButton && React.createElement("button", { onClick: () => {
                dispatch('chatbotService.askFormQuestion', `What is this field? ${sectionPath} ${fieldLabel}`, fieldPath);
            }, type: "button", style: { position: 'relative', top: "-3px" }, className: "w-4 h-4 ml-1 rounded-full bg-gray-300 hover:bg-gray-400 flex items-center justify-center text-xs text-gray-600 font-bold opacity-0 transform translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 ease-out" }, "?")));
}
